/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsDesignElement,
    SharedserviceMelcoModelsDesignElementFromJSON,
    SharedserviceMelcoModelsDesignElementFromJSONTyped,
    SharedserviceMelcoModelsDesignElementToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsUpdateDesign
 */
export interface SharedserviceMelcoModelsUpdateDesign {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsUpdateDesign
     */
    name?: string | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsDesignElement>}
     * @memberof SharedserviceMelcoModelsUpdateDesign
     */
    element_list?: Array<SharedserviceMelcoModelsDesignElement> | null;
}

export function SharedserviceMelcoModelsUpdateDesignFromJSON(json: any): SharedserviceMelcoModelsUpdateDesign {
    return SharedserviceMelcoModelsUpdateDesignFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsUpdateDesignFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsUpdateDesign {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'element_list': !exists(json, 'element_list') ? undefined : (json['element_list'] === null ? null : (json['element_list'] as Array<any>).map(SharedserviceMelcoModelsDesignElementFromJSON)),
    };
}

export function SharedserviceMelcoModelsUpdateDesignToJSON(value?: SharedserviceMelcoModelsUpdateDesign | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'element_list': value.element_list === undefined ? undefined : (value.element_list === null ? null : (value.element_list as Array<any>).map(SharedserviceMelcoModelsDesignElementToJSON)),
    };
}


